import "bijou/base";

const bindChatEvents = (elm) => {
  $(elm).on("keyup keypress click", ".Twilio-EntryPoint", function () {
    EventTracker.trigger("chat_events", "chat_opened");
  });

  $(elm).on("keyup keypress click", ".Twilio-DynamicForm-submit", function () {
    EventTracker.trigger("chat_events", "chat_started");
  });
};

$(document).ready(function () {
  const elm = ".questionnaire";
  if ($(elm).length > 0) {
    bindChatEvents(elm);
  }
});

export { bindChatEvents };
